import { axios } from '@/utils/request'

/**
 * 修改密码
 * @param parameter
 * @returns {*}
 */
export function modifyPassword (parameter) {
  return axios({
    url: '/user/modify-password',
    method: 'post',
    data: parameter
  })
}
